import type { GlobalSearchResult, ModuleSearchAdapter } from "../types";
import { getSearchClient } from "../apiClient";

interface DocsSearchItem {
  id: string;
  title: string | null;
  excerpt?: string | null;
  updated_at: string;
}

interface DocsSearchResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: DocsSearchItem[];
}

function mapItem(d: DocsSearchItem): GlobalSearchResult {
  return {
    id: `docs:${d.id}`,
    moduleId: "docs",
    title: d.title ?? "(Untitled)",
    subtitle: d.excerpt ?? undefined,
    timestamp: d.updated_at,
    href: `/write/${d.id}`,
  };
}

export const docsAdapter: ModuleSearchAdapter = {
  moduleId: "docs",
  label: "Write",
  async search(q, signal) {
    const res = await getSearchClient().get<DocsSearchResponse>(
      `/api/docs/documents/search/?q=${encodeURIComponent(q)}&page_size=3`,
      { signal },
    );
    return res.results.map(mapItem);
  },
};
